import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';
import { ConfigState } from './config.reducer';

export const selectConfig = (state: AppState) => state.configState;

export const selectConfigData = createSelector(selectConfig, (state: ConfigState) => state.config);
